import { useControllerContext } from "../../../../hooks/controller-context";
import {
  TimerControllerBackgroundBox,
  TimerControllerInputBox,
} from "../../../../style";
import { ControllerTournamentInputWrapper } from "../../../tournament-info/style";
import { useTournamentUser } from "../../hooks/use-tournament-user";
import { ControllerSitInPlayerWrapper } from "./style";

const TimerControllerUserCount = () => {
  const {
    userCountInput,
    setUserCountInput,
    handleUpdateUserCount,
    handleInputUserCount,
  } = useTournamentUser();
  const { data } = useControllerContext();

  return (
    <ControllerSitInPlayerWrapper>
      <TimerControllerBackgroundBox height="198px">
        <div className="title">현재 플레이어 조정</div>
        <ControllerTournamentInputWrapper>
          <img
            src="/image-web/controller/minus.svg"
            alt="minus"
            onClick={() => handleUpdateUserCount(-1)}
          />
          <TimerControllerInputBox height="64px">
            <input
              value={userCountInput}
              onChange={(e) => setUserCountInput(+e.target.value)}
              placeholder="조절할 TOTAL STACK 입력"
              onKeyDown={(e) => {
                if (e.key === "Enter") handleInputUserCount();
              }}
              onClick={(e) => e.currentTarget.select()}
            />
          </TimerControllerInputBox>
          <img
            src="/image-web/controller/plus.svg"
            alt="plus"
            onClick={() => handleUpdateUserCount(1)}
          />
        </ControllerTournamentInputWrapper>
      </TimerControllerBackgroundBox>
      <TimerControllerBackgroundBox width="488px" height="198px">
        <div className="title">리엔트리 플레이어</div>
        <div className="box">{data?.reBuyInUserCount}</div>
      </TimerControllerBackgroundBox>
      <TimerControllerBackgroundBox width="488px" height="198px">
        <div className="title">애드온 플레이어</div>
        <div className="box">{data?.adOnUserCount}</div>
      </TimerControllerBackgroundBox>
    </ControllerSitInPlayerWrapper>
  );
};

export default TimerControllerUserCount;
